import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import PortfolioList from '../components/portfolio/PortfolioList';
import Footer from '../components/footer/Footer';

const Portfolio = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (

        <>
            {isSideNavOpen && <SideNavigation />}
            <Header />

            <main>
                <PortfolioList />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default Portfolio;